import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item"]
  static values = { speed: { type: Number, default: 4000 } }

  declare readonly itemTargets: HTMLElement[]
  declare readonly speedValue: number

  index = 0
  timer?: number

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
    this.timer = window.setInterval(() => this.rotate(), this.speedValue)
  }

  disconnect() {
    window.clearInterval(this.timer)
  }

  next() {
    this.show(this.index + 1)
  }

  previous() {
    this.show(this.index - 1)
  }

  private rotate() {
    if (this.element.matches(":hover, :focus-within")) return
    this.show(this.index + 1)
  }

  private show(index: number) {
    this.index = (index + this.itemTargets.length) % this.itemTargets.length
    this.itemTargets.forEach((item, i) => {
      item.hidden = i !== this.index
    })
  }
}
